export default {
  coffeeData: {
    windBreaker: "Albero di rottura del vento",
    horticultureInfo: "Albero di orticoltura",
    shadeTree: "Albero di ombre",
    coffeeVariety: "Varietà di caffè",
    coffeeSpecies: "Specie di caffè",
    coffeeCherryQuality: "Qualità della Ciliegia di Caffè",
    processingBatchQuality: "Qualità del Lotto di Lavorazione",
    greenCoffeeQuality: "Qualità del Caffè Verde",
    processType: "Tipo di Processo",
    updateWindBreaker: "Aggiorna il vento Tipo di albero di rottura",
    addWindBreaker: "Aggiungi nuovo ventoBreaker Tipo albero",
    updateHorticultureInfo:
      "Aggiornamento orticoltura Informazioni Tipo albero",
    addHorticultureInfo: "Aggiungi nuova orticoltura Informazioni Tipo albero",
    updateShadeTree: "Aggiorna l'ombra Tipo albero albero",
    addShadeTree: "Aggiungi nuova tonalità Tipo albero albero",
    updateCoffeeVariety: "Aggiornare il caffè Tipo di albero variegato",
    addCoffeeVariety: "Aggiungi nuovo caffèVariety Albero Tipo",
    deleteVarietyTitle: "Eliminare la varietà",
    deleteVarietyMessage: "Sei sicuro di voler eliminare Variety?",
    updateCoffeeSpecie: "Aggiornamento Caffè Specie",
    deleteSpecieTitle: "Eliminare la specie",
    deleteSpecieMessage: "Sei sicuro di voler eliminare Specie?",
    addCoffeeSpecie: "Aggiungere Nuova varietà di caffè",
    variety: "Varietà",
    selectVariety: "Selezionare Specie",
    deleteCoffeeRecord: "Sei sicuro di voler eliminare il record?",
    deleteCoffeeData: "Eliminare i dati del caffè",
    topicRequired: "Seleziona argomento è necessario",
    coffeeAddSuccess: "Caffè Specie aggiunto con successo.",
    treeTypeSuccess: "Tipo di albero aggiunto con successo.",
    treeTypeUpdateSuccess: "Tipo di albero aggiornato con successo.",
    coffeeVarietySuccess: "Varietà di caffè aggiunto con successo.",
    coffeeSpecieSuccess: "Caffè specie aggiornato con successo.",
    nameRequired: "Il nome è richiesto",
    notFound: "No Admin Dati del caffè Trovato",
  },
  cacaoData: {
    cacao: "Cacao",
    cacaoVariety: "Varietà di Cacao",
    cacaoSpecies: "Cacao Specie",
    cacaoWeight: "Cacao Peso",
    cacaoOverview: "Cacao Panoramica",
    cacaoType: "Cacao Tipo",
    deleteCacaoData: "Eliminare i dati di Cacao",
    productWeight: "Peso del prodotto",
    productType: "Tipo di prodotto",
    productPricePerKg: "Prezzo per KG",
    registerFermentation: "Fermentazione del registro",
    batchVisualIdentification: "Indentificazione visiva batch",
    initialWeight: "Peso iniziale",
    finalWeight: "Peso finale",
    performance: "Prestazioni",
    fermentationPercentage: "Percentuale di fermentazione",
    fermetationMethod: "Metodo di fermentazione",
    boxes: "Boxe",
    piles: "Celle",
    bags: "Borse",
    selectZone: "Seleziona la zona",
    selectPlantation: "Seleziona la piantagione",
    deliveryMethod: "Metodo di consegna",
    totalPrice: "Prezzo totale",
  },
  memberDataSection: {
    import: "Importazioni",
    buyingStation: "Comprare la stazione",
    factory: "Fabbrica",
    factories: "Fabbriche",
    factoriesName: "Nome della Fabbrica",
    factoriesProdChart: "Grafico di produzione delle fabbriche",
    factoryInfo: "Informazioni Fabbrica",
    continue: "Continua",
    farmerId: "ID azienda agricola",
    farmerName: "Nome del coltivatore",
    farmerAddress: "Farmer Indirizzo",
    quality: "Qualità",
    quantity: "Quantità",
    importAll: "Importa tutto",
    importSelected: "Importo selezionato",
    fileLoaded: "File caricato con successo",
    incorrectHeaders: "Intestazioni scorrette",
    processingBatch: "Elaborazione Batch",
    purchaseOrder: "Ordine di acquisto",
    startDate: "Data di inizio",
    endDate: "Data di fine",
    selectCrop: "Seleziona Coltura",
    purchasingOrder: "Ordine di acquisto",
    totalCoffeeCherry: "Ciliegia totale del caffè",
    airHumidity: "Umidità dell'aria",
    density: "Densità",
    temperature: "Temperatura",
    beanMoistureContent: "Contenuto della piantagione di fagioli",
    processType: "Tipo di processo",
    batchRating: "Seleziona la valutazione del batch",
    purchaseDate: "Data di acquisto",
    selectFarmer: "Seleziona Farmer",
    selectFarmers: "Seleziona Farmers",
    selectFarm: "Seleziona Agriturismo",
    selectPlantation: "Seleziona la piantagione",
    coffeeVariety: "Varietà di caffè",
    coffeeSpecies: "Specie di caffè",
    coffeeCherryQuantity: "Ciliegia di caffè quantità",
    coffeeCherryQuality: "Qualità del caffè",
    coffeeType: "Tipo di caffè",
    pricePerKg: "Prezzo per Kg",
    processingDone: "Fatto di elaborazione",
    processedCoffeeOut: "Caffè lavorato fuori",
    farmer: "Farmer",
    farm: "Fattoria",
    plantation: "Piantatura",
    farmers: "Agricoltori",
    farmLimitUsed: "Limite di fattoria utilizzato",
    phoneNumber: "Numero di telefono",
    farmSize: "Dimensione della fattoria",
    farmLocation: "Fattoria/Locazione",
    date: "Data",
    status: "Stato",
    noFarmers: "Nessun Agriturismo Trovato",
    approveReject: "Approvo/Rigetto",
    farms: "Aziende agricole",
    crops: "Croci",
    equipment: "Attrezzatura",
    noFarms: "Nessun agriturismo Trovato",
    views: "Vista",
    selectStatus: "Selezionare Stato",
    approved: "Approvazione",
    rejected: "Rifiuti",
    reject: "Rifiuti",
    approve: "Approvo",
    conclude: "Concludi",
    cancel: "Annulla",
    add: "Aggiungi",
    describeYourReason: "Descrivi il tuo motivo qui",
    userInformation: "Informazioni utente",
    userFarmRequest: "Richiesta dell'utente",
    userFarmInformation: "User Farm(s) Informazioni",
    activity: "Attività",
    activityType: "Tipo di attività",
    farmZone: "Zona agricola",
    farmerView: "Vista sul mare",
    cropType: "Tipo di coltura",
    cropVarity: "Varietà del raccolto",
    area: "Settore",
    cost: "Costo",
    geofence: "Geofence",
    map_views: "Visualizza mappa",
    viewAllFarms: "Visualizza tutti gli agriturismi",
    farmersDetails: "Dettagli dell'agriturismo",
    download: "Scarica",
    pOrder: {
      addNew: "Aggiungi nuovo",
      viewAll: "Vedi tutto",
      selectDate: "Seleziona la data",
      makeSelection: "Fai una selezione",
      coffeeType: "Tipo di caffè quantità",
      enterPrice: "Inserisci il prezzo",
      reqPurchaseDate: "La data di acquisto è richiesta",
      reqFarmer: "L'agricoltore è richiesto",
      reqCoffeeQnty: "Ciliegia di caffè Quantità è richiesto",
      reqPrice: "Prezzo per Kg è richiesto",
      grandTotal: "GRAND TOTALE",
      selectDateRange: "Seleziona l'intervallo di date",
      import: "Importazioni",
      purchaseId: "Acquisto Id",
      purchaseDate: "Data di acquisto",
      farmerName: "Nome del coltivatore",
      quality: "Qualità",
      quantity: "Quantità",
      pricePerKg: "Prezzo per Kg",
      selectBuyingStation: "Selezionare la stazione di acquisto",
      searchUser: "Utenti di ricerca",
      calendarView: "Calendario vista",
      purchaseListView: "Lista di acquisto",
      viewBy: "Vista da",
      typeDensity: "Tipo Densità",
      typeTemperature: "Tipo di temperatura",
      typeWaterContent: "Tipo contenuto di acqua",
    },
    farmActivity: "Attività agricola",
    showOnMap: "Mostra sulla mappa",
    farmInformation: "Informazioni sull'azienda",
    dateOfEntry: "Data di entrata",
    farmID: "ID azienda agricola",
    ownershipType: "Tipo di proprietà",
    locationAddress: "Indirizzo",
    goalType: "Tipo di gol",
    totalSize: "Dimensione totale",
    zones: "Zone",
    farmActivities: "Farm Activites",
    farmDetails: "Dettagli dell'agriturismo",
    totalFarmsRegistered: "Totale aziende",
    totalFarmArea: "Totale superficie agricola",
    totalZone: "Zona totale",
    zone: "Zona",
    totalCost: "Costo totale",
    selectFarmZone: "Seleziona Zona/Farm",
    productionType: "Tipo di produzione",
    certifications: "Certifications",
    geofences: "Geofences",
    farmsChart: "Grafico delle fattorie",
  },
 
    // Buying Station specific translations
    buyingStations: "Stazioni di acquisto",
    registerBuyingStation: "Registra stazione di acquisto",
    registerFactory: "Registra fabbrica",
    loadingFactory: "Caricamento fabbrica...",
    loadingBuyingStation: "Caricamento stazione di acquisto...",
    searchBuyingStation: "Cerca stazione di acquisto",
    searchFactory: "Cerca fabbrica",
    nameAndId: "Nome / ID",
    email: "Email",
    mobileNumber: "Numero di cellulare",
    role: "Ruolo",
    actions: "Azioni",
    view: "Visualizza",
    edit: "Modifica",
    activate: "Attiva",
    deactivate: "Disattiva",
    operator: "Operatore",
    supplier: "Fornitore",
    active: "Attivo",
    deactivated: "Disattivato",
    activatedSuccessfully: "Stazione di acquisto attivata con successo",
    deactivatedSuccessfully: "Stazione di acquisto disattivata con successo",
  
    factoryActivatedSuccessfully: "Fabbrica attivata con successo",
    factoryDeactivatedSuccessfully: "Fabbrica disattivata con successo",
    factoryRegisteredSuccessfully: "Fabbrica registrata con successo",
    
    // Buying Station Details specific translations
    userDetails: "Dettagli utente",
    name: "Nome",
    provinceState: "Provincia/Stato",
    villageCityTown: "Villaggio/Città/Cittadina",
    country: "Paese",
    associatedFarms: "Fattorie associate",
    back: "Indietro",
    addPurchaseOrder: "Aggiungi ordine di acquisto",
    search: "Cerca",
    orderId: "ID ordine",
    farmFarmer: "Fattoria / Agricoltore",
    coffeeSpeciesVariety: "Specie / Varietà di caffè",
    quantityPrice: "Quantità / Prezzo",
    delete: "Elimina",
    
    // Processing Batch specific translations
    addProcessingBatch: "Aggiungi lotto di lavorazione",
    batchId: "ID lotto",
    lots: "Lotti",
    greenCoffeeOut: "Caffè verde fuori",
    startEndDate: "Data inizio/Data fine",
    
    // Associated Farms specific translations
    addFarm: "Aggiungi fattoria",
    farmNameAndId: "Nome e ID fattoria",
    addressOfProduction: "Indirizzo di produzione",
    areaHa: "Area (ha)",
    type: "Tipo",
    eudrDeforestationStatus: "Stato disboscamento EUDR",
    eudrDeforestationStatusTT: "Stato valutazione rischio disboscamento EUDR",
    zeroNegligibleProbability: "Probabilità zero/trascurabile",
    assessments: "Valutazioni",
    riskAssessment: "Valutazione del rischio",
    compliant: "Conforme",
    nonCompliant: "Non conforme",
    pending: "In attesa",
    dateOfSubmission: "Data di invio",
    dateOfExpiry: "Data di scadenza",
    
    greenCoffee: {
      processGreenCoffee: "Processare Caffè Verde",
      lotIdOutturnNo: "ID Lotto / N. Produzione",
      startDate: "Data di inizio",
      complete: "Completo",
      quantity: "Quantità",
      totalGreenBeansExceeded: "La quantità totale classificata non può superare il totale dei chicchi verdi.",
      toAddRecord: "per aggiungere un record.",
      registeredSuccess: "Caffè verde registrato con successo",
      exportNotImplemented: "Esportazione non implementata",
      processingBatchRequired: "Il lotto di lavorazione è obbligatorio",
      outturnAvailable: "Il numero di produzione è disponibile",
      outturnExists: "Questo numero di produzione esiste già. Inserire un valore univoco.",
      totalGreenBeansRequired: "Il totale dei chicchi verdi è obbligatorio",
      enterHere: "Inserire qui",
      viewTitle: "Classificazione qualità chicchi verdi",
      parchmentInformation: "Informazioni pergamino",
      processInformation: "Informazioni processo",
      greenBeansInformation: "Informazioni chicchi verdi",
      traceabilityLabel: "Etichetta di tracciabilità",
      waste: "Scarto",
      downloadLabel: "Scarica etichetta",
      startCupping: "Avvia degustazione",
      cuppingHistory: "Cronologia degustazione",
      noDataFound: "Nessun dato trovato.",
      noParchmentBatches: "Nessun lotto pergamino collegato.",
      noQualityGrades: "Nessuna qualità registrata.",
      batchId: "ID lotto",
      species: "Specie",
      variety: "Varietà",
      process: "Processo",
      batchRating: "Valutazione lotto",
      humidity: "Umidità",
      totalCoffeeCherryQty: "Quantità totale ciliegia",
      weightBeforeProcessing: "Peso prima della lavorazione",
      numberOfBags: "Numero di sacchi",
      externalId: "ID esterno",
      qrCode: "Codice QR",
      latestCuppingScore: "Punteggio degustazione più recente",
      totalWaste: "Scarto totale",
      close: "Chiudi",
      unitSizeKgBag: "Dimensione unità (kg/sacco)",
      grade: "Grado",
      selectGrade: "Seleziona grado",
      quantityRequired: "La quantità è obbligatoria",
      quantityMustBePositive: "La quantità deve essere maggiore di 0",
      unitSizeRequired: "La dimensione unità è obbligatoria",
      unitSizeMustBePositive: "La dimensione unità deve essere maggiore di 0",
      gradeRequired: "Il grado è obbligatorio",
      labelRequired: "L'etichetta è obbligatoria",
      cupping: "Degustazione",
      cuppingInformation: "Informazioni degustazione",
      cupperName: "Nome assaggiatore",
      cuppingDate: "Data degustazione",
      enterCupperName: "Inserire nome assaggiatore",
      attachFiles: "Allega file",
      selectFilesToUpload: "Seleziona file da caricare",
      orDragAndDrop: "oppure trascina e rilascia qui",
      sessionDetails: "Dettagli sessione",
      noCuppingHistory: "Nessuna cronologia degustazione per questo caffè verde.",
      cuppingDataSaved: "Dati degustazione salvati.",
      date: "Data",
      roast: "Tostatura",
      score: "Punteggio",
      outturnNumber: "Numero produzione",
      totalQuantity: "Quantità totale",
      supplier: "Fornitore",
      density: "Densità",
      airHumidity: "Umidità aria",
      batchProductionDensity: "Densità produzione lotto",
      qualityScore: "Punteggio qualità",
      percentagePrimaryDefect: "Percentuale difetto primario",
      percentageSecondaryDefect: "Percentuale difetto secondario",
      totalGreenBeans: "Totale chicchi verdi (kg)",
      leftoverQuantity: "Quantità residua",
      expiryDate: "Data di scadenza",
      label: "Etichetta",
      qualityControl: "Controllo qualità",
      packing: "Imballaggio",
      totalBags: "Totale sacchi",
      percentage: "Percentuale",
    },
    confirmDialog: {
      delete: {
        title: "Elimina stazione di acquisto",
        message: "Sei sicuro di voler eliminare questa stazione di acquisto?",
        confirmBtn: "Elimina",
      },
      activate: {
        title: "Attiva",
        message: "Sei sicuro di voler attivare questo {entity}?",
        confirmBtn: "Attiva",
      },
      deactivate: {
        title: "Disattiva",
        message: "Sei sicuro di voler disattivare questo {entity}?",
        confirmBtn: "Disattiva",
      },
    },
    
    registerNewFactory: "Registra nuova fabbrica",
    selectHowYouWantToProceed: "Seleziona come desideri procedere",
    single: "Singolo",
    multiple: "Multiplo",
    user: "Utente",
    createNewFactory: "Crea nuova fabbrica",
    factoryName: "Nome fabbrica",
    factoryNumber: "Numero fabbrica",
    firstName: "Nome",
    lastName: "Cognome",
    primaryEmailAddress: "Indirizzo email principale",
    submit: "Invia",
    downloadTemplate: "Scarica modello",
    templateInfo: "Scarica il file modello per vedere il formato richiesto per la registrazione in massa.",
    templateFormat: "Per favore, fornisci il file in formato CSV.",
    selectFileToUpload: "Seleziona il file per caricare i dati",
    uploadFileOrDragAndDrop: "o trascina e rilascia qui",
};
